import { AxiosError } from 'axios';

export const isAxiosError = (e: unknown): e is AxiosError => (e as AxiosError)?.isAxiosError === true;
